module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "form-ui column default-form-ui",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "ctn-big-block"
  }, [_c('text-input', {
    attrs: {
      "name": "product",
      "label": "Produit"
    },
    model: {
      value: (_vm.investmentProduct.product_name),
      callback: function($$v) {
        _vm.$set(_vm.investmentProduct, "product_name", $$v)
      },
      expression: "investmentProduct.product_name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ctn-big-block ctn-big-block row"
  }, [_c('div', {
    staticClass: "ctn-duo-input row"
  }, [_c('div', {
    staticClass: "left inner-duo"
  }, [_c('text-input', {
    attrs: {
      "name": "subscription_date",
      "label": "Date de souscription",
      "type": "date"
    },
    model: {
      value: (_vm.investmentProduct.subscription_date),
      callback: function($$v) {
        _vm.$set(_vm.investmentProduct, "subscription_date", $$v)
      },
      expression: "investmentProduct.subscription_date"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "right inner-duo"
  }, [_c('div', {
    directives: [{
      name: "selectUI",
      rawName: "v-selectUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('product_type')
    }
  }, [_c('label', {
    attrs: {
      "for": "product_type"
    }
  }, [_vm._v("Type de produit")]), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.productTypes
    },
    model: {
      value: (_vm.investmentProduct.product_type),
      callback: function($$v) {
        _vm.$set(_vm.investmentProduct, "product_type", $$v)
      },
      expression: "investmentProduct.product_type"
    }
  })], 1), _vm._v(" "), (_vm.errors.has('product_type')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('product_type')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "ctn-big-block ctn-big-block row"
  }, [_c('div', {
    staticClass: "ctn-duo-input row"
  }, [_c('div', {
    staticClass: "left inner-duo"
  }, [_c('text-input', {
    attrs: {
      "name": "contract_number",
      "label": "Numéro de contrat"
    },
    model: {
      value: (_vm.investmentProduct.contract_number),
      callback: function($$v) {
        _vm.$set(_vm.investmentProduct, "contract_number", $$v)
      },
      expression: "investmentProduct.contract_number"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "right inner-duo"
  }, [_c('div', {
    directives: [{
      name: "selectUI",
      rawName: "v-selectUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('contract_type')
    }
  }, [_c('label', {
    attrs: {
      "for": "contract_type"
    }
  }, [_vm._v("Type de contrat")]), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.contractTypes
    },
    model: {
      value: (_vm.investmentProduct.contract_type),
      callback: function($$v) {
        _vm.$set(_vm.investmentProduct, "contract_type", $$v)
      },
      expression: "investmentProduct.contract_type"
    }
  })], 1), _vm._v(" "), (_vm.errors.has('contract_type')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('contract_type')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "ctn-big-block row"
  }, [_c('div', {
    staticClass: "ctn-duo-input row"
  }, [_c('div', {
    staticClass: "left inner-duo"
  }, [_c('text-input', {
    attrs: {
      "name": "shares_number",
      "label": "Parts",
      "type": "number"
    },
    model: {
      value: (_vm.investmentProduct.shares_number),
      callback: function($$v) {
        _vm.$set(_vm.investmentProduct, "shares_number", $$v)
      },
      expression: "investmentProduct.shares_number"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "right inner-duo"
  }, [_c('div', {
    staticClass: "inner-row"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label ctn-currency",
    class: {
      error: _vm.errors.has('shares_number')
    }
  }, [_c('label', {
    class: {
      'active': _vm.investmentProduct.share_price_currency
    },
    attrs: {
      "for": "shares_number"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tPrix de la part\n\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.investmentProduct.share_price),
      expression: "investmentProduct.share_price"
    }],
    ref: "share_price",
    attrs: {
      "type": "number",
      "name": "share_price"
    },
    domProps: {
      "value": (_vm.investmentProduct.share_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.investmentProduct, "share_price", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.currencyList
    },
    model: {
      value: (_vm.investmentProduct.share_price_currency),
      callback: function($$v) {
        _vm.$set(_vm.investmentProduct, "share_price_currency", $$v)
      },
      expression: "investmentProduct.share_price_currency"
    }
  })], 1), _vm._v(" "), (_vm.errors.has('share_price')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('share_price')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "ctn-big-block row"
  }, [_c('div', {
    staticClass: "ctn-duo-input row"
  }, [_c('div', {
    staticClass: "left inner-duo"
  }, [_c('div', {
    staticClass: "inner-row"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label ctn-currency",
    class: {
      error: _vm.errors.has('net_income_distributed')
    }
  }, [_c('label', {
    staticClass: "active",
    attrs: {
      "for": "net_income_distributed"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tRevenu net distribué\n\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.investmentProduct.net_income_distributed),
      expression: "investmentProduct.net_income_distributed"
    }],
    ref: "net_amount_distributed",
    attrs: {
      "type": "number",
      "name": "net_income_distributed"
    },
    domProps: {
      "value": (_vm.investmentProduct.net_income_distributed)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.investmentProduct, "net_income_distributed", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.currencyList
    },
    model: {
      value: (_vm.investmentProduct.net_income_distributed_currency),
      callback: function($$v) {
        _vm.$set(_vm.investmentProduct, "net_income_distributed_currency", $$v)
      },
      expression: "investmentProduct.net_income_distributed_currency"
    }
  })], 1), _vm._v(" "), (_vm.errors.has('net_income_distributed')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('net_income_distributed')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "right inner-duo"
  }, [_c('div', {
    staticClass: "inner-row"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label ctn-currency",
    class: {
      error: _vm.errors.has('subscription_price')
    }
  }, [_c('label', {
    attrs: {
      "for": "subscription_price"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tPrix d'achat de la part\n\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.investmentProduct.subscription_price),
      expression: "investmentProduct.subscription_price"
    }],
    ref: "subscription_price",
    attrs: {
      "type": "number",
      "name": "subscription_price"
    },
    domProps: {
      "value": (_vm.investmentProduct.subscription_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.investmentProduct, "subscription_price", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.currencyList
    },
    model: {
      value: (_vm.investmentProduct.share_price_currency),
      callback: function($$v) {
        _vm.$set(_vm.investmentProduct, "share_price_currency", $$v)
      },
      expression: "investmentProduct.share_price_currency"
    }
  })], 1), _vm._v(" "), (_vm.errors.has('subscription_price')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('subscription_price')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "ctn-big-block row",
    staticStyle: {
      "justify-content": "left"
    }
  }, [_c('div', {
    staticClass: "left inner-duo",
    staticStyle: {
      "width": "calc(50% - 0.5rem)"
    }
  }, [_c('div', {
    staticClass: "inner-row"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label ctn-currency",
    class: {
      error: _vm.errors.has('income_since_anniversary')
    }
  }, [_c('label', {
    staticClass: "active",
    attrs: {
      "for": "income_since_anniversary"
    }
  }, [_vm._v("\n\t\t\t\t\t\tRevenus depuis la date d'anniversaire\n\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.investmentProduct.income_since_anniversary),
      expression: "investmentProduct.income_since_anniversary"
    }],
    ref: "income_since_anniversary",
    attrs: {
      "type": "number",
      "name": "income_since_anniversary"
    },
    domProps: {
      "value": (_vm.investmentProduct.income_since_anniversary)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.investmentProduct, "income_since_anniversary", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.currencyList
    },
    model: {
      value: (_vm.investmentProduct.share_price_currency),
      callback: function($$v) {
        _vm.$set(_vm.investmentProduct, "share_price_currency", $$v)
      },
      expression: "investmentProduct.share_price_currency"
    }
  })], 1), _vm._v(" "), (_vm.errors.has('income_since_anniversary')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('income_since_anniversary')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "ctn-cta row start"
  }, [_c('router-link', {
    staticClass: "ctn-icon",
    attrs: {
      "to": {
        name: 'InvestmentsManual',
        params: {
          clientId: _vm.clientId,
          kind: _vm.isCgpi ? 'cgpi' : 'client'
        }
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-gold"
  }, [_vm._v("Annuler")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-red",
    class: {
      'btn-disabled': !_vm.isFormValidated || _vm.isFormLoading
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n\t\t\tEnregistrer\n\t\t")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f1c2722"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/InvestmentsManual/EditForm/Main.vue
// module id = 1155
// module chunks = 0